import { render } from "./FireVehicleList.vue?vue&type=template&id=c282c940&scoped=true"
import script from "./FireVehicleList.vue?vue&type=script&lang=ts"
export * from "./FireVehicleList.vue?vue&type=script&lang=ts"

import "./FireVehicleList.vue?vue&type=style&index=0&id=c282c940&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c282c940"

export default script